
import React from "react";
import CreateAttributeList from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import {  defaultDropList } from "../Data/WBComponentDefaults";
import { WBRenderProps } from "vagaro-website-rendering/src/components/Definitions/WBRenderProps";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import { ResizeableType, WBComponent } from "./WBComponent";
import LayoutNode, {  getNodeComponentAttributeValue, setNodeStyleAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import SimpleImageSlider from "react-simple-image-slider";
import { AttributeDefinition, AttributeInputType } from "../Data/WBData";
import { ScreenSize } from "vagaro-website-rendering/src/components/Definitions/ScreenSize";
import MissingSourceDisplay from "vagaro-website-rendering/src/components/MissingSourceDisplay";
import { assignDomRef, GetNodeComponenentAttributeBinding, GetNodeDomAttributes } from "vagaro-website-rendering/src/components/Utilities/GetNodeDomAttributes";
import WebDesigner from "../WebDesigner";


export default class ImageSlider extends WBComponent{

    constructor(){
        super();
        this.typename =  wBComponentTypeNames.imageSlider;
        this.dropList = defaultDropList
        this.displayName = "Image Slider";
        this.resizeType = ResizeableType.All;
        this.icon = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" fill="currentColor"><path d="M64 464l284.5 0c12.3 18.8 28 35.1 46.3 48L64 512c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64l384 0c23.8 0 44.5 12.9 55.5 32.2c-2.5-.1-5-.2-7.5-.2c-26.2 0-51.1 5.7-73.4 16L64 208c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16zM440 80c13.3 0 24 10.7 24 24s-10.7 24-24 24L72 128c-13.3 0-24-10.7-24-24s10.7-24 24-24l368 0zM392 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L120 48c-13.3 0-24-10.7-24-24s10.7-24 24-24H392zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H512V304z"/></svg>
        this.editList = ["imageSliderList","imageSliderControls","imageSliderAutoplay","imageSliderDelay",...CreateAttributeList(true,false,true,true,false)];
        this.primaryEditAttributes = ["imageSliderList","imageSliderControls","imageSliderAutoplay","imageSliderDelay"];
        this.defaultGridSize = {width:500,height:300};
    }

    getComponentSpecificAttributeDefinitions(): AttributeDefinition[] {

        return [

            new AttributeDefinition("imageSliderList","Images","",AttributeInputType.ImageField,[],{min:0,max:12,step:1,unit:""}),
            new AttributeDefinition("imageSliderControls","Show Controls","",AttributeInputType.ButtonField,
            [
                {label:"Auto",value:""},
                {label:"Hide",value:"false"},
                {label:"Show",value:"true"}

            ]),
            new AttributeDefinition("imageSliderAutoplay","Autoplay","",AttributeInputType.ButtonField,
            [
                {label:"Auto",value:""},
                {label:"On",value:"true"},
                {label:"Off",value:"false"}

            ]),
            new AttributeDefinition("imageSliderDelay","Autoplay Delay","",AttributeInputType.RangeSliderField,[],{min:1,max:10,step:.1,unit:"sec"}),
        ]
    }

    onFirstTimeCreation(newParent: LayoutNode, thisLayout: LayoutNode, manager: WebDesigner): void {

        setNodeStyleAttributeValue(thisLayout,ScreenSize.Desktop,"height","300px");
        setNodeStyleAttributeValue(thisLayout,ScreenSize.Desktop,"width","500px");
    }

    RenderLayout({component,children,screenSize,userContext: siteData,isEditor}:WBRenderProps): JSX.Element {


        let imageList = getNodeComponentAttributeValue(component,"imageSliderList","");
        const controls = getNodeComponentAttributeValue(component,"imageSliderControls","true")== "true";
        const delay = parseFloat(getNodeComponentAttributeValue(component,"imageSliderDelay","5"));
        const autoplay = getNodeComponentAttributeValue(component,"imageSliderAutoplay","")== "true" && delay>0;

        let imageListArray =  imageList.length>0?imageList.split(","):[];
        let classn = (imageListArray.length<=0)?" v-image-slider-empty":"v-image-slider";
        const atts = GetNodeDomAttributes(classn,component,screenSize,isEditor);
        if(imageListArray.length<=0){

            return (

                <div {...atts}>
                     <MissingSourceDisplay/>
                </div>
            )

        }


        return <div {...atts} {...GetNodeComponenentAttributeBinding(component,isEditor)}>

        {/* <RenderImageSlider component={component} screenSize={screenSize} userContext={siteData} isEditor={isEditor} children={undefined}/> */}
        <SimpleImageSlider
                key ={imageListArray.length>0?imageListArray[0]+autoplay+delay:"empty"} //udpate the key when the image list changes in order to update the slider in real time
                width={500}
                height={300}
                images={imageListArray}
                showBullets={controls}
                showNavs={controls}
                autoPlay={autoplay}
                autoPlayDelay={delay}
            />
        </div>
    }

}
